import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, arrayMove } from "@dnd-kit/sortable";
import { Image } from "antd";
import { HolderOutlined, CloseOutlined } from "@ant-design/icons";

const SortableItem = ({ file, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: file.uid,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: isDragging ? "grabbing" : "grab",
    marginBottom: 8,
    padding: "8px 12px",
    border: "1px solid #d9d9d9",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    zIndex: isDragging ? 100 : "auto",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <HolderOutlined
        {...attributes}
        {...listeners}
        style={{ cursor: "grab", marginRight: 8 }}
        title="拖动调整顺序"
      />

      <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
        {file.url || file.thumbUrl ? (
          <Image
            src={file.url || file.thumbUrl}
            width={32}
            height={32}
            style={{ marginRight: 8 }}
            preview={false}
          />
        ) : (
          <span style={{ marginRight: 8 }}>{file.name}</span>
        )}
        <span
          style={{
            maxWidth: "70%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {file.name}
        </span>
      </div>

      <CloseOutlined onClick={() => onRemove(file)} style={{ cursor: "pointer", color: "#999" }} />
    </div>
  );
};

export const SortableUploadList = ({ fileList, onSort, onRemove }) => {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const items = fileList.map((file) => file.uid);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = items.indexOf(active.id);
      const newIndex = items.indexOf(over.id);

      const newOrderedList = arrayMove(fileList, oldIndex, newIndex);

      onSort(newOrderedList);
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {fileList.map((file) => (
          <SortableItem key={file.uid} file={file} onRemove={onRemove} />
        ))}
      </SortableContext>
    </DndContext>
  );
};
